import { Query } from 'best-modules/utils'
import { PaginationList } from 'best-modules/components/server-table/types'
import { sendRequest } from 'best-modules/vue-utils'
import {
  InternalStaffUnit,
  InternalStaffUnitCredentials,
} from '@/utils/types/internalStaffUnit'

const internalStaffUnitList = (
  query: Query
): Promise<PaginationList<InternalStaffUnit>> => {
  return sendRequest({
    name: 'internalStaffUnitList',
    method: 'get',
    url: {
      url: '/json/orgStructure/staffUnit',
      query,
    },
  })
}

const internalStaffUnitCreate = (
  credentials: InternalStaffUnitCredentials
): Promise<InternalStaffUnit> => {
  return sendRequest({
    name: 'internalStaffUnitCreate',
    method: 'post',
    url: '/json/orgStructure/staffUnit',
    payload: credentials,
  })
}

const internalStaffUnitUpdate = (
  id: number,
  credentials: InternalStaffUnitCredentials
): Promise<InternalStaffUnit> => {
  return sendRequest({
    name: 'internalStaffUnitUpdate',
    method: 'put',
    url: `/json/orgStructure/staffUnit/${id}`,
    payload: credentials,
  })
}

const internalStaffUnitDelete = (id: number): Promise<InternalStaffUnit> => {
  return sendRequest({
    name: 'internalStaffUnitDelete',
    method: 'delete',
    url: `/json/orgStructure/staffUnit/${id}`,
  })
}

const internalStaffUnitSingle = (id: number): Promise<InternalStaffUnit> => {
  return sendRequest({
    name: 'internalStaffUnitSingle',
    method: 'get',
    url: `/json/orgStructure/staffUnit/${id}`,
  })
}

export {
  internalStaffUnitList,
  internalStaffUnitDelete,
  internalStaffUnitUpdate,
  internalStaffUnitCreate,
  internalStaffUnitSingle,
}
